import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import FineNumber from '../../FineInformation/components/FineNumber'
import ConfirmFineNumber from '../../FineInformation/components/ConfirmFineNumber'
import {
  screenLoadingAction,
  clearFineAction,
  addFineAction,
  editFineNumberAction,
  minPaymentAmountAction,
  fineOwingAction,
  caseSotIdAction,
  receiptDetailAction,
  fineTypeAction,
} from 'redux/actions'
import { getfineOweAmountAction } from 'redux/reducers/apiReducers/fineOweAmountReducer'
import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'

const AddFineView = ({ t, i18n, setIsError }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const [fineNumberValid, setFineNumberValid] = useState('')
  const [confirmFineNumberValid, setConfirmFineNumberValid] = useState('')
  const [errMsg, setErrMsg] = useState('')

  const [fineNumberError, setFineNumberError] = useState('fine_information.fine_number_error')
  const [fineNumberJEINError, setFineNumberJEINError] = useState('')
  const [confirmFineNumberError, setConfirmFineNumberError] = useState('fine_information.confirm_fine_number_error')

  const fineNumber = useSelector((state) => state.app.fineNumber)
  const confirmFineNumber = useSelector((state) => state.app.confirmFineNumber)

  const fines = useSelector((state) => state.app.fines)

  const editFineNumberStore = useSelector((state) => state.app.editFineNumber)

  useEffect(() => {
    try {
      dispatch(clearFineAction())
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const onAddFine = () => {
    try {
      if (validateFields()) {
        setErrMsg('')
        dispatch(screenLoadingAction())
        dispatch(getServiceAvailableAction())
          .then((res) => {
            if (res['data']) {
              dispatch(getfineOweAmountAction({ caseNumber: fineNumber }))
                .then((res) => {
                  if (!res['validationFailureMessage'] && !isNaN(res['amountOwing']) && res['amountOwing'].toString().indexOf('.') !== -1) {
                    if (validateCASESOTExist(res['receiptDetail'])) {
                      setFineNumberValid(false)
                      setFineNumberError('fine_information.fine_number_exist')
                    } else {
                      if (res['paymentAdjustmentMessage'] && res['paymentAdjustmentMessage'].includes('Full payment must be made.')) {
                        processPaymentFullFine(res)
                      } else {
                        fineNotFullProcess(res)
                      }
                    }
                  } else {
                    setFineNumberValid(false)
                    setFineNumberJEINError(i18n.language === 'en' ? res['validationFailureMessage'] : res['validationFailureMessageFr'])
                  }
                  dispatch(screenLoadingAction())
                })
                .catch((e) => {
                  setFineNumberValid(false)
                  setFineNumberError('fine_information.service_not_available_error')
                  console.log(e)
                  dispatch(screenLoadingAction())
                })
            } else {
              setErrMsg('fine_information.service_not_available_error')
              dispatch(screenLoadingAction())
            }
          })
          .catch((e) => {
            console.log(e)
            setErrMsg('fine_information.service_not_available_error')
            dispatch(screenLoadingAction())
          })
      }
    } catch (e) {
      console.log(e)
      setFineNumberValid(false)
      setFineNumberError('fine_information.service_not_available_error')
    }
  }

  const processPaymentFullFine = (res) => {
    try {
      dispatch(
        addFineAction({
          fineNumber,
          fineOwing: res['amountOwing'],
          paymentAmount: res['amountOwing'],
          minPaymentAmount: res['minimumPaymentAmount'],
          paymentAmountFull: true,
          caseSotId: res['caseSotId'],
          receiptDetail: res['receiptDetail'],
          fineType: res['caseSotValue'],
        })
      )
      dispatch(clearFineAction())
      dispatch(editFineNumberAction(''))
      history.push(`/${i18n.language}${t('routes.listed_fines')}`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const fineNotFullProcess = (res) => {
    dispatch(fineOwingAction(res['amountOwing'].toString()))
    dispatch(minPaymentAmountAction(res['minimumPaymentAmount'].toString()))
    dispatch(fineTypeAction(res['caseSotValue']))
    dispatch(receiptDetailAction(res['receiptDetail']))
    dispatch(caseSotIdAction(res['caseSotId']))
    history.push(`/${i18n.language}${t('routes.fine_owing_info')}`)
  }

  const validateFields = () => {
    try {
      validateFineNumber(fineNumber)
      validateConfirmFineNumber(confirmFineNumber)
      if (fineNumber === '') {
        setFineNumberValid(false)
      }
      if (confirmFineNumber === '') {
        setConfirmFineNumberValid(false)
      }
      return (
        fineNumberValid === true &&
        confirmFineNumberValid === true &&
        fineNumber !== '' &&
        confirmFineNumber !== '' &&
        fineNumber === confirmFineNumber
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFineExist = (fine) => {
    try {
      if (editFineNumberStore === fine) {
        return false
      }
      return fines.find((fineInfo) => fineInfo.fineNumber === fine)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateCASESOTExist = (caseSOT) => {
    try {
      return fines.find((fineInfo) => fineInfo.caseSotId.includes(caseSOT) || caseSOT.includes(fineInfo.caseSotId))
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFineNumber = (fine) => {
    try {
      setFineNumberJEINError('')
      const regex = RegExp(/^\d+$/)
      if (fine !== '') {
        if (regex.test(fine)) {
          if (fine.length > 0) {
            if (validateFineExist(fine)) {
              setFineNumberValid(false)
              setFineNumberError('fine_information.fine_number_exist')
            } else {
              setFineNumberValid(true)
            }
          } else {
            setFineNumberValid(false)
            setFineNumberError('fine_information.fine_number_less')
          }
        } else {
          setFineNumberValid(false)
          setFineNumberError('fine_information.fine_number_invalid')
        }
      } else {
        setFineNumberValid(false)
        setFineNumberError('fine_information.fine_number_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateConfirmFineNumber = (number) => {
    try {
      if (number && number === fineNumber) {
        setConfirmFineNumberValid(true)
      } else {
        setConfirmFineNumberValid(false)
        setConfirmFineNumberError('fine_information.confirm_fine_number_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <h2>{t('fines_list.or_add_another_fine')}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <FineNumber
            validateFineNumber={validateFineNumber}
            fineNumberError={fineNumberError}
            fineNumberValid={fineNumberValid}
            fineNumberJEINError={fineNumberJEINError}
            setIsError={setIsError}
          />
          <ConfirmFineNumber
            validateConfirmFineNumber={validateConfirmFineNumber}
            confirmFineNumberError={confirmFineNumberError}
            confirmFineNumberValid={confirmFineNumberValid}
            setIsError={setIsError}
          />
        </div>
      </div>
      <div className="form-group has-error">
        <button
          className="btn-lg btn-default"
          style={{ marginBottom: errMsg === '' ? '' : '5px' }}
          onClick={onAddFine}
          value={t('fines_list.add_fine')}
          name={t('fines_list.add_fine')}
        >
          {t('fines_list.add_fine')}
        </button>{' '}
        {errMsg === '' ? '' : <i className="fa fa-exclamation-circle" aria-hidden="true" />}
        <div className="help-block">{t(errMsg)}</div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(AddFineView)
